
import "@sparta.global.utilities/sparta-spinner-utility/dist/styles.css"
import "@sparta.global.utilities/sparta-footnote-utility/dist/styles.css"


import syncAlloyUtility from "@sparta.global-vtim.utilities/sync-alloy-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import syncTaggingUtility from "@sparta.global-vtim.utilities/sync-tagging-utility/dist/es6.js"
import ahVendorWrapperUtility from "@sparta.authglobal.utilities/ah-vendor-wrapper-utility/dist/es6.js"

import "@sparta.merrilledge.modules/bootstrap-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.sales.modules/eyebrow-banner-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-es6" */ "@sparta.sales.modules/eyebrow-banner-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-styles" */ "@sparta.sales.modules/eyebrow-banner-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/masthead-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-masthead-module-es6" */ "@sparta.merrilledge.modules/masthead-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-masthead-module-styles" */ "@sparta.merrilledge.modules/masthead-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/stock-global-index-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-stock-global-index-module-es6" */ "@sparta.merrilledge.modules/stock-global-index-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-stock-global-index-module-styles" */ "@sparta.merrilledge.modules/stock-global-index-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/merrill-modal-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-merrill-modal-module-es6" */ "@sparta.merrilledge.modules/merrill-modal-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-merrill-modal-module-styles" */ "@sparta.merrilledge.modules/merrill-modal-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/merrilledge-common-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-merrilledge-common-module-es6" */ "@sparta.merrilledge.modules/merrilledge-common-module/dist/es6.js" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/retirement-calculator-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-retirement-calculator-module-es6" */ "@sparta.merrilledge.modules/retirement-calculator-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-retirement-calculator-module-styles" */ "@sparta.merrilledge.modules/retirement-calculator-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/find-the-investing",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-find-the-investing-es6" */ "@sparta.merrilledge.modules/find-the-investing/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-find-the-investing-styles" */ "@sparta.merrilledge.modules/find-the-investing/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/support-guidance-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-support-guidance-module-es6" */ "@sparta.merrilledge.modules/support-guidance-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-support-guidance-module-styles" */ "@sparta.merrilledge.modules/support-guidance-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/investing-and-banking-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-investing-and-banking-module-es6" */ "@sparta.merrilledge.modules/investing-and-banking-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-investing-and-banking-module-styles" */ "@sparta.merrilledge.modules/investing-and-banking-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/accolade-reviews-section-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-accolade-reviews-section-module-es6" */ "@sparta.merrilledge.modules/accolade-reviews-section-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-accolade-reviews-section-module-styles" */ "@sparta.merrilledge.modules/accolade-reviews-section-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/ready-to-get-started-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-ready-to-get-started-module-es6" */ "@sparta.merrilledge.modules/ready-to-get-started-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-ready-to-get-started-module-styles" */ "@sparta.merrilledge.modules/ready-to-get-started-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/connect-with-advisor-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-connect-with-advisor-module-es6" */ "@sparta.merrilledge.modules/connect-with-advisor-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-connect-with-advisor-module-styles" */ "@sparta.merrilledge.modules/connect-with-advisor-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/your-money-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-your-money-module-es6" */ "@sparta.merrilledge.modules/your-money-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-your-money-module-styles" */ "@sparta.merrilledge.modules/your-money-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/bonus-offer-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-bonus-offer-module-es6" */ "@sparta.merrilledge.modules/bonus-offer-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-bonus-offer-module-styles" */ "@sparta.merrilledge.modules/bonus-offer-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/power-footer-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-power-footer-module-es6" */ "@sparta.merrilledge.modules/power-footer-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-power-footer-module-styles" */ "@sparta.merrilledge.modules/power-footer-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/login-secure-ah-omni-channel-auth-first-factor-module-es6" */ "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/login-secure-ah-omni-channel-auth-first-factor-module-styles" */ "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/fifa-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-fifa-module-es6" */ "@sparta.merrilledge.modules/fifa-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-fifa-module-styles" */ "@sparta.merrilledge.modules/fifa-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/footnotes-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-footnotes-module-es6" */ "@sparta.merrilledge.modules/footnotes-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-footnotes-module-styles" */ "@sparta.merrilledge.modules/footnotes-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.sales-onecms.modules/feature-block-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-onecms-feature-block-module-es6" */ "@sparta.sales-onecms.modules/feature-block-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-onecms-feature-block-module-styles" */ "@sparta.sales-onecms.modules/feature-block-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.sales-onecms.modules/universal-container-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-onecms-universal-container-module-es6" */ "@sparta.sales-onecms.modules/universal-container-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-onecms-universal-container-module-styles" */ "@sparta.sales-onecms.modules/universal-container-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.login.shared-components/ah-secure-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-secure-signin-shared-component-es6" */ "@sparta.login.shared-components/ah-secure-signin-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-passkey-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-passkey-signin-shared-component-es6" */ "@sparta.login.shared-components/ah-passkey-signin-shared-component/dist/es6.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-bootstrap-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-bootstrap-store-es6" */ "@sparta.global-tenants.stores/gt-unauth-bootstrap-store/dist/es6.js" )}
    }
  ],
  jcrs: [
    {
      name: "site/merrilledge-dap/module-specific-v2/bootstrap-module/en/bootstrap.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-bootstrap-module-en-bootstrap.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-bootstrap-module-en-bootstrap-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/eyebrow-banner/eyebrow-banner.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-eyebrow-banner-eyebrow-banner.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-eyebrow-banner-eyebrow-banner-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/bootstrap-module/en/spinner-data.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-bootstrap-module-en-spinner-data.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-bootstrap-module-en-spinner-data-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/bootstrap-module/en/chat.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-bootstrap-module-en-chat.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-bootstrap-module-en-chat-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/retirement-calculator-module/retirement-calculator-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-retirement-calculator-module-retirement-calculator-module.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-retirement-calculator-module-retirement-calculator-module-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/investing-and-banking-module/investing-and-banking-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-investing-and-banking-module-investing-and-banking-module.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-investing-and-banking-module-investing-and-banking-module-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/find-the-investing-module/find-the-investing.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-find-the-investing-module-find-the-investing.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-find-the-investing-module-find-the-investing-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/support-guidance-module/support-guidance.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-support-guidance-module-support-guidance.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-support-guidance-module-support-guidance-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/accolade-reviews-section-module/accolade-reviews-section-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-accolade-reviews-section-module-accolade-reviews-section-module.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-accolade-reviews-section-module-accolade-reviews-section-module-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/connect-with-advisor/connect-with-advisor.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-connect-with-advisor-connect-with-advisor.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-connect-with-advisor-connect-with-advisor-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/your-money-module/your-money.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-your-money-module-your-money.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-your-money-module-your-money-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/ready-to-get-started-module/ready-to-get-started-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-ready-to-get-started-module-ready-to-get-started-module.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-ready-to-get-started-module-ready-to-get-started-module-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/connect-with-advisor/connect-with-advisor.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-connect-with-advisor-connect-with-advisor.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-connect-with-advisor-connect-with-advisor-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/masthead-module/masthead.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-masthead-module-masthead.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-masthead-module-masthead-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/bonus-offer-module/bonus-offer.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-bonus-offer-module-bonus-offer.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-bonus-offer-module-bonus-offer-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/power-footer-module/power-footer.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-power-footer-module-power-footer.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-power-footer-module-power-footer-en-T1789053550205.json" )}
    },
    {
      name: "site/secure-ah-hybrid-shared-components/module-specific/ah-secure-signin-shared-component/en/error-v1.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-error-v1.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-error-v1-en-T1789053550205.json" )}
    },
    {
      name: "site/secure-ah-hybrid-shared-components/module-specific/ah-secure-signin-shared-component/en/data-v1.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-data-v1.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-data-v1-en-T1789053550205.json" )}
    },
    {
      name: "site/ah-secure-login/module-specific/hybrid/client-site-config.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ah-secure-login-module-specific-hybrid-client-site-config.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-ah-secure-login-module-specific-hybrid-client-site-config-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/fifa-module/fifa-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-fifa-module-fifa-module.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-fifa-module-fifa-module-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/footnotes-module/footnotes.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-footnotes-module-footnotes.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-footnotes-module-footnotes-en-T1789053550205.json" )}
    },
    {
      name: "site/merrilledge-dap/module-specific-v2/footnotes-module/broker-check.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-dap-module-specific-v2-footnotes-module-broker-check.json" */ "file:///apps/wt/deploy/tmp/EC15BD8F/build/sit2a/site/merrilledge-dap/spa-assets/data/site-merrilledge-dap-module-specific-v2-footnotes-module-broker-check-en-T1789053550205.json" )}
    }
  ]
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
ahVendorWrapperUtility.init();
  console.log('after - execute boot functions')
})();
